import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: 'https://7rgitwv5nvcy7dc4hogvcbwvpy.appsync-api.us-east-2.amazonaws.com/graphql',
      region: 'us-east-2',
      defaultAuthMode: 'apiKey',
      apiKey: 'da2-joacghietnewzo65dta3v3cfum'
    }
  }
});

export const client = generateClient();
